export default "__VITE_ASSET__DPV58PS7__"